// extracted by mini-css-extract-plugin
export var skipAnimation = "_15-0";